import { validation } from '@/util/validation.js';
export default {

  searchShow: true,
  searchMenuSpan: 6,
  calcHeight: 120,
  align: 'right',
  emptyBtn:false,
  submitBtn:false,
  tip: false,
  border: true,
  index: true,
  viewBtn: true,
  delBtn: true,
  selection: true,
  menuWidth: 200,
  column: [
    {
      label: '车牌号',
      prop: 'plateNumber',
      filterable: false,
      span: 12,
      rules: [
        {
          required: true,
          message: '请输入车牌号',
          trigger: 'change',
        },
        {
          pattern: validation.carPlate,
          message: '车牌号格式错误',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '车场名称',
      prop: 'spaceIds',
      hide: true,
      multiple: true,
      leafOnly: true,
      defaultExpandAll: true,
      span: 12,
      type: 'tree',
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [{
        required: true,
        message: '请选择车场',
        trigger: 'change',
      },],
    },
    {
      label: '车主姓名',
      prop: 'driverName',
      placeholder: '请输入车主名称',
      span: 12,
      maxlength: 32,
      rules: [
        {
          required: true,
          message: '请输入姓名',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '车主电话',
      prop: 'mobile',
      span: 12,
      rules: [
        {
          required: true,
          message: '请输入手机号码',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '单位信息',
      prop: 'companyName',
      span: 12,
      maxlength: 32,
      search: true,
    },
    {
      label: '开始时间',
      prop: 'startDate',
      span: 12,
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      rules: [
        {
          required: true,
          message: '请选择开始时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '结束时间',
      prop: 'endDate',
      span: 12,
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      rules: [
        {
          required: true,
          message: '请选择结束时间',
          trigger: 'change',
        },
      ],
    },
    {
      label: '类型',
      prop: 'blackType',
      span: 12,
      type: 'select',
      value: 0,
      dicData: [
        { label: '白名单', value: 0 },
        { label: '黑名单', value: 1 },
      ],
      rules: [
        {
          required: true,
          message: '请选择名单类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '授权类型',
      prop: 'parkAreaRightType',
      span: 12,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      value: 0,
      display: true,
      rules: [
        {
          required: true,
          message: '请选择授权类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '备注',
      prop: 'remark',
      type: 'textarea',
      span: 24,
      minRows: 2,
      maxlength: 100,
      overHidden: true,
      showWordLimit: true,
    },
  ],
}
